import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Story from "@/pages/Story";
import MenuPage from "@/pages/Menu";
import Order from "@/pages/Order";
import Catering from "@/pages/Catering";
import Book from "@/pages/Book";
import Shop from "@/pages/Shop";
import Schedule from "@/pages/Schedule";
import Franchise from "@/pages/Franchise";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/story" element={<Story />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/order" element={<Order />} />
            <Route path="/catering" element={<Catering />} />
            <Route path="/book" element={<Book />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/franchise" element={<Franchise />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Contact />} />
            <Route path="/careers" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
